var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_c('div',{staticClass:"sss",domProps:{"innerHTML":_vm._s(_vm.textinfo)}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{class:{ cen: true, active: !_vm.flag },on:{"click":_vm.change}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59a43e3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mytips/tips.vue
// module id = null
// module chunks = 